<div class="app flex-row align-items-center">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-6">
                <div class="clearfix">
                    <h1 class="float-left display-3 mr-4">403</h1>
                    <h4 class="pt-3">Oops! Access Denied.</h4>
                    <p class="text-muted">You Don't Have Permission To View This Page.</p>
                </div>
                <div class="input-prepend input-group">
                    <span class="input-group-append">
                        <button class="btn btn-info" type="button" (click)="loginAgain()">LogIn</button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>